export function installTranslationGuard(): void {
  if (typeof Node !== 'function' || !Node.prototype) return
  const proto = Node.prototype as any
  if (proto.__translationGuard) return
  proto.__translationGuard = true

  const originalRemoveChild = proto.removeChild
  proto.removeChild = function removeChild<T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Skipped removeChild on a node moved by page translation', child)
      }
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = proto.insertBefore
  proto.insertBefore = function insertBefore<T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Skipped insertBefore on a node moved by page translation', referenceNode)
      }
      return newNode
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}
